// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mfe-beh-smart-groups-system-floating-msg-container {
  position: relative;
}

.mfe-beh-smart-groups-system-floating-msg {
  left: 0;
  right: 0;
  top: auto;
  margin-left: auto;
  margin-right: auto;
  width: 990px;
}

label {
  text-transform: none !important;
}

input {
  border-radius: 0;
  background-color: white;
}

textarea {
  background-color: white;
}`, "",{"version":3,"sources":["webpack://./app/root-component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;;AACA;EACI,OAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;AAEJ;;AACA;EACI,+BAAA;AAEJ;;AAEA;EACI,gBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,uBAAA;AACJ","sourcesContent":[".__mfe__system-floating-msg-container {\r\n    position: relative;\r\n}\r\n.__mfe__system-floating-msg {\r\n    left: 0;\r\n    right: 0;\r\n    top: auto;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    width: 990px;\r\n}\r\n// make text-transform: none !important; for all labels to avoid conflicts with node modules label style. common for all labels in this mfe\r\nlabel {\r\n    text-transform: none !important;\r\n}\r\n\r\n// for balancing the global css coming from App shell\r\ninput {\r\n    border-radius: 0;\r\n    background-color: white;\r\n}\r\n\r\ntextarea {\r\n    background-color: white;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
